<template>
  <div id="app">
    <transition name='router-slid'>
    	<router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>  
html{
  font-family: sans-serif;
  -webkit-touch-callout:none;
  -webkit-text-size-adjust:none;
  -webkit-tap-highlight-color:rgba(0, 0, 0, 0);
  -webkit-user-select:none;
  background-color: #fff;
  min-height: 100vh; 
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
}
html,body,header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p,i,td,th {
  margin:0;
  border:0;
  padding:0;
  font-style:normal;
  box-sizing: border-box;
  color: #1d1d26;
}

body, button, input, select, textarea { 
  font:0.28rem/1.5; 
  background: #fff;
  -webkit-appearance: none; 
  border:0;
  margin:0;
  padding:0;  
  background-color:rgba(0, 0, 0, 0);
}
body{
    height: 100%;
    width: 100%;
    max-width:750px;
    margin:0 auto;
}
nav,article,aside,details,main,header,footer,section,fieldset,figcaption,figure{display: block;}
h1, h2, h3, h4, h5, h6{ font-size:100%; }
ol,ul{list-style:none;}
a {color: #333;}
sup { vertical-align:text-top; }
sub{ vertical-align:text-bottom; }
a,a:hover,a:active,a:link,a:visited{ text-decoration:none;  outline: 0;}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.clearfix:after{
  content: ' ';
  display: block;
  clear: both;
  visibility:hidden;
  line-height: 0;
  height:0;
}
.plative{position: relative;}

.clearfix{*+height:1%;}
.tc{text-align: center;};
.ellipsis{white-space:nowrap; overflow:hidden;text-overflow:ellipsis; } 
.lineclamp1{overflow: hidden;display: -webkit-box; word-break: break-all;-webkit-line-clamp: 1;text-overflow: ellipsis; -webkit-box-orient: vertical;}
.lineclamp2{overflow: hidden;display: -webkit-box; word-break: break-all;-webkit-line-clamp: 2;text-overflow: ellipsis; -webkit-box-orient: vertical;height: 1rem;line-height: .5rem}

.fade-leave-active{
  opacity: 0;
  transition: all 0s ease;
}
.fade-enter-active{
   transition: all .5s ease;
}
.fade-enter{
  transform: translateX(100%);
  opacity: 0;
}
.router-slid-leave-active{
  opacity: 0;
}
.router-slid-enter-active{
  transition: all .3s;
  transition: transform .3s cubic-bezier(.23, 1, .23, 1), opacity .3s cubic-bezier(.23, 1, .23, 1);
  transform-origin: center top;
}
.router-slid-enter {
  backface-visibility: hidden;
  transform: translate3d(2rem, 0, 0);
  opacity: 0;
}
.router-slid-leave{}
</style>



// WEBPACK FOOTER //
// App.vue?8a2710f2